import {defer,forkJoin,Observable,of} from 'rxjs';
import {map} from 'rxjs/operators';
import {firestore} from 'firebase';

/** The installed Firestore SDK supports ten IDs per query; retain Elastic's ranking. */
export function currentDocumentPage$<T>(collection:firestore.CollectionReference,guids:string[],convert:(doc:firestore.QueryDocumentSnapshot)=>T):Observable<T[]> {
    const ids=Array.from(new Set(guids));
    if(!ids.length) {return of([]);}
    const batches:Observable<Array<{id:string,value:T}>>[]=[];
    for(let start=0;start<ids.length;start+=10) {
        const batch=ids.slice(start,start+10);
        batches.push(defer(()=>collection.where(firestore.FieldPath.documentId(),'in',batch).get({source:'server'})).pipe(
            map(snapshot=>snapshot.docs.map(doc=>({id:doc.id,value:convert(doc)})))
        ));
    }
    return forkJoin(batches).pipe(map(pages=>{
        const current=new Map<string,T>();pages.forEach(page=>page.forEach(row=>current.set(row.id,row.value)));
        return ids.filter(id=>current.has(id)).map(id=>current.get(id));
    }));
}
